import mapboxgl from "mapbox-gl";

import { REPORT_SELECTION_LINE_PAINT } from "../constants";
import { prepareSaveButton } from "../helpers/forms";
import { captureMapCanvas } from "../helpers/map";
import RecenterControl from "../mapbox/controls/recenterControl";
import ApplicationController from "./application_controller";

const TILES_URL =
  "https://geoservices.brgm.fr/geologie?version=1.3.0&request=GetMap&crs=EPSG:3857&bbox={bbox-epsg-3857}&width=256&layers=SCAN_D_GEOL50&height=256&styles=default&format=image/png";

export default class extends ApplicationController {
  static targets = ["map"];
  static values = {
    geoInfo: Object,
  };

  connect() {
    super.connect();
    const geoInfo = this.geoInfoValue;
    mapboxgl.accessToken = gon.global.mapbox_token;
    const map = new mapboxgl.Map({
      container: this.mapTarget,
      style: "mapbox://styles/mapbox/outdoors-v11",
      center: geoInfo.center,
      zoom: geoInfo.zoom,
      preserveDrawingBuffer: true,
    });
    map.addControl(new mapboxgl.NavigationControl());
    map.addControl(new RecenterControl(), "top-right");
    map.addControl(new mapboxgl.ScaleControl(), "bottom-right");
    const controller = this;

    map.on("load", () => {
      map.addSource("scan-geol50", {
        type: "raster",
        tiles: [TILES_URL],
        tileSize: 256,
      });
      map.addLayer(
        {
          id: "scan-geol50-raster",
          type: "raster",
          source: "scan-geol50",
          paint: {},
        },
        "building"
      );

      map.addSource("report-selection", {
        type: "geojson",
        data: geoInfo.selection,
      });
      map.addLayer({
        id: "report-selection-line",
        type: "line",
        source: "report-selection",
        paint: REPORT_SELECTION_LINE_PAINT,
      });

      map.on("idle", () => {
        controller.ready = true;
      });
      controller.map = map;
    });
  }

  saveMap(event) {
    event.preventDefault();
    if (!this.ready) {
      return;
    }
    const { signedGid, attribute } = prepareSaveButton(event);
    const imageBase64 = captureMapCanvas(this.map).toDataURL("image/jpeg", 0.85);
    this.stimulate("FormReflex#update", signedGid, attribute, imageBase64, true);
  }
}
